import { ResourceTicketRequest, ResourceTicketResponse } from '../../models/resource-services';
import { FetchContext, responseErrorHandler } from '../../api';

export const getResource: (
  fetchContext: FetchContext,
  request: ResourceTicketRequest,
  accessToken?: string,
) => Promise<ResourceTicketResponse> = (fetchContext, request, accessToken) => fetch(`${fetchContext.baseUrl}/api/resources/download/ticket`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  })
  .then((response) => responseErrorHandler<ResourceTicketResponse>(fetchContext.errorStore, response, 'get resource'));
